import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ChatInterface from '../astrology/components/ChatInterface';
import SEOSchema from '../../components/feature/SEOSchema';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const fourPillarsSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': `${siteUrl}/four-pillars`,
  name: '사주팔자 분석 — AI 사주 운세 서비스',
  description: '사주팔자(四柱八字)로 당신의 인생 흐름을 파악합니다. 생년월일시의 네 기둥으로 운명의 구조를 AI가 분석해드립니다.',
  url: `${siteUrl}/four-pillars`,
  provider: {
    '@type': 'Organization',
    name: 'DESTINY GPT',
    url: siteUrl,
  },
  serviceType: '사주팔자 AI 분석',
  areaServed: { '@type': 'Country', name: '대한민국' },
  inLanguage: 'ko-KR',
};

export default function FourPillarsPage() {
  return (
    <div className="min-h-screen bg-cosmic-gradient">
      <SEOSchema schema={fourPillarsSchema} id="four-pillars-schema" />
      <Navbar />

      <main className="pt-16 sm:pt-20">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-8 sm:py-12">
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-3 sm:mb-4">
              사주 분석
            </h1>
            <p className="text-base sm:text-xl text-primary-light">
              사주팔자로 당신의 인생 흐름을 파악합니다
            </p>
          </div>

          <ChatInterface serviceType="four-pillars" />
        </div>
      </main>

      <Footer />
    </div>
  );
}
